export default __webpack_public_path__ + "static/media/prizeq.237ba9bb.png";